import React from "react";
import ContactInfo from "./ContactInfo";
// import GlobalOffice from "./GlobalOffice";
import ContactFrom from "./ContactFrom";

const Contact = () => {
  return (
    <div>
      <ContactInfo />
      {/* <GlobalOffice /> */}
      <ContactFrom />
    </div>
  );
};

export default Contact;
